module.exports = __webpack_public_path__ + "static/media/assasins_hood.646d6ab0.png";